import styled from 'styled-components';
import { BodyLarge500, BodyMedium500 } from '@nebula/global-styles';
import { commonUi } from '../../../constants';

const { mobileHeaderHeightPx, tabletPortraitHeaderHeightPx, smallDesktopHeaderHeightPx } = commonUi.layout;

export const PageContainer = styled.div<{ isWebview: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.5rem 1rem 1.5rem 1rem;
  align-items: center;
  justify-content: center;
  min-height: ${({ isWebview }) => (isWebview ? '100dvh' : `calc(100dvh - ${mobileHeaderHeightPx}px)`)};
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    background-color: ${({ theme }) => theme.color.ui.grey[10]};
    min-height: ${({ isWebview }) => (isWebview ? '100dvh' : `calc(100dvh - ${tabletPortraitHeaderHeightPx}px)`)};
    padding: 2rem 1.5rem 2.5rem 1.5rem;
  }
  @media ${({ theme }) => theme.media.smallDesktopMin} {
    min-height: ${({ isWebview }) => (isWebview ? '100dvh' : `calc(100dvh - ${smallDesktopHeaderHeightPx}px)`)};
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 2rem 0;
  background-color: ${({ theme }) => theme.color.ui.white};
  max-width: 480px;
  border-radius: 1rem;
`;

export const NebulaLoadingContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  height: 1.5rem;

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    height: 2.125rem;
  }
`;

export const LoaderTitle = styled(BodyLarge500)`
  margin: 0;
`;

export const LoaderSubTitle = styled(BodyMedium500)`
  margin: 0;
`;

export const LoaderTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
`;
